import React from 'react';
import '../../styles/Features.css';
import TimeCostIcon from '../../Assets/Icons/save-30-days-with-galaxy-crystalline-waterproofing.webp';
import WarrantyIcon from '../../Assets/Icons/25-years-warranty-galaxy-uae.webp';
import LiquidAdmixtureIcon from '../../Assets/Icons/only-liquid-crystalline-admixture-uae-25-years-warranty.webp';

const features = [
  {
    title: 'Save 30–40 Days on Construction',
    description: 'Our crystalline admixture is mixed at the batching plant — no membrane laying, no delays. Save weeks on your Dubai project.',
    icon: TimeCostIcon,
  },
  {
    title: '25 Years Warranty',
    description: 'We back every waterproofing solution with a 25-year product and service warranty — unmatched in the UAE.',
    icon: WarrantyIcon,
  },
  {
    title: 'Liquid Crystalline Admixture — Authorised UAE Distributor',
    description: 'Galaxy is the authorised distributor of Cormix liquid crystalline admixture in the UAE — computerised dosing, zero lumps, consistent quality on every pour.',
    icon: LiquidAdmixtureIcon,
  },
];

const Features = () => (
  <div className="features-section">
    <h2>Why Choose Galaxy Specialised Waterproofing?</h2>
    <div className="features-grid">
      {features.map((feature) => (
        <div key={feature.title} className="feature-card">
          <div className="feature-icon">
            <img src={feature.icon} alt={feature.title} width="50" height="50" />
          </div>
          <h3>{feature.title}</h3>
          <p>{feature.description}</p>
        </div>
      ))}
    </div>
  </div>
);

export default Features;
